'use strict';

import keymirror from 'keymirror';

export default keymirror({
    UPDATE_IS_CHUNK_LOADING: null,
});
